import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  hr: {
    translation: {
      "My Roof" : "Moj krov",
      "Im Interested" : "Intresira me",
      "Area" : "Površina",
      "Suitability" : "Pogodnost",
      "Note" : "Napomena",
      "Sort by" : "Sortiraj po",
      "results" : "rezultata",
      "High Suitability" : "Visoka pogodnost",
      "Good Suitability" : "Dobra pogodnost",
      "Low Suitability" : "Niska pogodnost",
      "Not Suitable" : "Nije pogodno",
      "Home" : "Početna",
      "Portal" : "Portal",
      "Search Area" : "Pretraži područje",
      "Only claimed" : "Samo zauzeti",
      "" : "",
      "" : "",
      
    }
  },
  sl: {
    translation: {
      "My Roof" : "Moja streha",
      "Im Interested" : "Sem zainteresiran",
      "Area" : "Območje",
      "Suitability" : "Primerenost",
      "Note" : "Opomba",
      "Sort by" : "Razvrsti po",
      "results" : "rezultate",
      "High Suitability" : "Visoka primerenost",
      "Good Suitability" : "Dobra primerenost",
      "Low Suitability" : "Nizka primernost",
      "Not Suitable" : "Ni primeren",
      "Home" : "Začetna",
      "Portal" : "Portal",
      "Search Area" : "Iskanje po območju",
      "Only claimed" : "Samo zahtevano",

    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;